{
  "actions": {
    "cancel": "Cancel",
    "create": "Create",
    "save": "Save",
    "link": "Link",
    "unlink": "Unlink"
  },
  "toasts": {
    "lessonCreated": "Lesson created successfully",
    "lessonCreateError": "Failed to create lesson",
    "moduleCreated": "Module created successfully",
    "moduleCreateError": "Failed to create module",
    "lessonDeleted": "Lesson removed",
    "lessonDeleteError": "Failed to remove lesson",
    "moduleDeleted": "Module removed",
    "moduleDeleteError": "Failed to remove module",
    "courseLinked": "Module linked to course",
    "courseLinkError": "Failed to link module to course",
    "courseUnlinked": "Module unlinked from course",
    "courseUnlinkError": "Failed to unlink module from course",
    "lessonLinked": "Lesson linked to module",
    "lessonLinkError": "Failed to link lesson",
    "lessonUnlinked": "Lesson unlinked from module",
    "lessonUnlinkError": "Failed to unlink lesson",
    "lessonMoved": "Lesson moved successfully",
    "lessonMoveError": "Failed to move lesson",
    "lessonsReorderError": "Failed to reorder lessons",
    "lessonUpdated": "Lesson updated",
    "lessonUpdateError": "Failed to update lesson",
    "moduleUpdated": "Module updated",
    "moduleUpdateError": "Failed to update module"
  },
  "lessonTypes": {
    "video": "Video",
    "text": "Text",
    "quiz": "Quiz",
    "assignment": "Assignment",
    "live": "Live"
  },
  "list": {
    "title": "Modules",
    "totalRegistered_one": "{{count}} module registered",
    "totalRegistered_zero": "{{count}} modules registered",
    "totalRegistered_other": "{{count}} modules registered",
    "subtitle": "Manage modules, sub-modules and lessons",
    "newModule": "New Module",
    "searchPlaceholder": "Search modules...",
    "pagination": {
      "showing": "Showing <bold>{{from}}</bold> – <bold>{{to}}</bold> of <bold>{{total}}</bold> modules",
      "previous": "Previous",
      "next": "Next"
    }
  },
  "table": {
    "loading": "Loading modules...",
    "empty": {
      "title": "No modules found",
      "searchHint": "Try a different search",
      "createHint": "Create your first module to organize lessons"
    },
    "columns": {
      "thumb": "Thumb",
      "name": "Name",
      "lessons": "Lessons",
      "courses": "Courses",
      "actions": "Actions"
    }
  },
  "row": {
    "edit": "Edit module",
    "delete": "Delete module",
    "deleteConfirm": {
      "title": "Delete module",
      "description": "Are you sure you want to delete \"{{title}}\"? This action cannot be undone.",
      "confirm": "Delete"
    }
  },
  "moduleForm": {
    "newModule": "New Module",
    "newSubModule": "New Sub-module",
    "name": "Name",
    "namePlaceholder": "Module name",
    "description": "Description",
    "descriptionPlaceholder": "Description (optional)",
    "thumbnail": "Thumbnail"
  },
  "edit": {
    "loading": "Loading module...",
    "notFound": "Module not found",
    "backToModules": "Back to modules",
    "modules": "Modules",
    "subModuleOf": "Sub-module of {{title}}",
    "tabs": {
      "basic": "Details",
      "content": "Content",
      "community": "Community"
    }
  },
  "content": {
    "newLesson": "New Lesson",
    "linkLesson": "Link Lesson",
    "linkCourse": "Link to Course",
    "lessonsCount": "Lessons ({{count}})"
  },
  "community": {
    "unavailable": {
      "locked": "locked showcase",
      "noPosts": "doesn't accept posts"
    },
    "notConfigured": {
      "title": "Community not configured",
      "description": "Set the <code>{{variable}}</code> variable on the backend and restart the server to enable linking tracks to community spaces."
    },
    "spaceLabel": "Community space",
    "loadingSpaces": "Loading spaces...",
    "chooseSpace": "Choose a space",
    "inherit": "Inherit from course",
    "help": "Choosing a space here overrides the course's space for this module's lessons only. Use \"Inherit from course\" to go back to the default.",
    "empty": "No spaces found in the community. Create a space there so you can link it here."
  },
  "lessonList": {
    "empty": "No lessons in this module",
    "columns": {
      "title": "Title",
      "type": "Type",
      "createdAt": "Created on",
      "actions": "Actions"
    }
  },
  "lessonRow": {
    "edit": "Edit lesson",
    "move": "Move to another module",
    "delete": "Delete lesson",
    "deleteConfirm": {
      "title": "Delete lesson",
      "description": "Are you sure you want to delete \"{{title}}\"?",
      "confirm": "Delete"
    }
  },
  "linkedCourses": {
    "title": "Linked courses",
    "unlink": "Remove link"
  },
  "subModules": {
    "title": "Sub-modules",
    "add": "Sub-module",
    "empty": "No sub-modules",
    "edit": "Edit sub-module",
    "delete": "Delete sub-module",
    "lessonCount_one": "{{count}} lesson",
    "lessonCount_zero": "{{count}} lessons",
    "lessonCount_other": "{{count}} lessons",
    "deleteConfirm": {
      "title": "Delete sub-module",
      "description": "Are you sure you want to delete \"{{title}}\"? This action cannot be undone.",
      "confirm": "Delete"
    }
  },
  "lessonForm": {
    "newTitle": "New Lesson",
    "editTitle": "Edit Lesson",
    "title": "Title",
    "titlePlaceholder": "Lesson title",
    "type": "Type",
    "description": "Description",
    "descriptionPlaceholder": "Description (optional)",
    "content": "Content",
    "contentPlaceholder": "Lesson content..."
  },
  "linkCourse": {
    "title": "Link to Course",
    "searchPlaceholder": "Search courses...",
    "notFound": "No courses found",
    "noPublished": "No published courses"
  },
  "linkLesson": {
    "title": "Link Existing Lesson",
    "searchPlaceholder": "Search lessons...",
    "notFound": "No lessons found",
    "typeToSearch": "Type to search"
  },
  "moveLesson": {
    "title": "Move Lesson",
    "selectTarget": "Select the destination module",
    "noModules": "No modules available",
    "moving": "Moving..."
  },
  "convertCourse": {
    "error": "Failed to convert course into module",
    "title": "Convert Course to Module",
    "description": "Turn \"{{title}}\" into a module",
    "warningTitle": "Warning",
    "warningDescription": "The course will be converted into a module and archived. All lessons will be kept inside the new module.",
    "stats": "$t(adminModules:convertCourse.modulesCount, {\"count\": {{modules}} }) · $t(adminModules:convertCourse.lessonsCount, {\"count\": {{lessons}} }) · $t(adminModules:convertCourse.studentsCount, {\"count\": {{students}} })",
    "modulesCount_one": "{{count}} module",
    "modulesCount_zero": "{{count}} modules",
    "modulesCount_other": "{{count}} modules",
    "lessonsCount_one": "{{count}} lesson",
    "lessonsCount_zero": "{{count}} lessons",
    "lessonsCount_other": "{{count}} lessons",
    "studentsCount_one": "{{count}} student",
    "studentsCount_zero": "{{count}} students",
    "studentsCount_other": "{{count}} students",
    "targetLabel": "Link to course (optional)",
    "targetSearchPlaceholder": "Search destination course...",
    "noTarget": "None (convert only)",
    "notFound": "No courses found",
    "targetHelp": "If selected, the new module will be automatically linked to this course",
    "submit": "Convert"
  },
  "videoUpload": {
    "label": "Lesson Video",
    "gumletLinked": "Gumlet video linked",
    "unsupportedFormat": "Unsupported format. Use MP4, WebM, MOV or AVI.",
    "tooLarge": "Video too large ({{size}}). Max: 5GB",
    "uploaded": "Video uploaded successfully",
    "noUrl": "Couldn't get the video URL",
    "uploadError": "Failed to upload video",
    "previewTitle": "Video preview",
    "gumletId": "Gumlet ID: {{id}}",
    "directUpload": "Direct upload",
    "remove": "Remove Video",
    "gumletPlaceholder": "Paste the Gumlet video ID",
    "invalidId": "Invalid ID. It must be 24 hexadecimal characters.",
    "previewUrl": "Preview: {{url}}",
    "showDirectUpload": "Or upload a file directly",
    "directUploadTitle": "Direct Upload (S3)",
    "uploading": "Uploading video...",
    "dropHint": "Drag or click to select (MP4, WebM, MOV, AVI - max 5GB)",
    "linkTitle": "Video link (YouTube, Vimeo or Panda Video)",
    "linkPlaceholder": "Paste the video link",
    "linkInvalid": "Link not recognized. Use a YouTube, Vimeo or Panda Video link.",
    "linkDetected": "{{provider}} video detected",
    "linkLinked": "Video linked",
    "linkedFrom": "Playing in the area player · {{provider}}",
    "gumletTitle": "Or use a video hosted on Gumlet",
    "streamTitle": "Video with protected streaming (recommended)"
  },
  "quizForm": {
    "newTitle": "New Quiz",
    "editTitle": "Edit Quiz",
    "description": "Set up the quiz questions",
    "basicInfo": "Basic Information",
    "settings": "Settings",
    "submitCreate": "Create Quiz",
    "submitUpdate": "Update Quiz",
    "validation": {
      "optionTextRequired": "Option text is required",
      "questionRequired": "Question is required",
      "pointsMin": "Points must be greater than 0",
      "optionsMin": "At least one option is required",
      "titleRequired": "Title is required",
      "timeLimitMin": "Time limit must be greater than 0",
      "passingScoreRange": "Score must be between 0 and 100",
      "maxRetriesMin": "Maximum attempts must be greater than 0",
      "questionsMin": "At least one question is required"
    },
    "fields": {
      "title": "Title *",
      "titlePlaceholder": "E.g.: Module 1 Assessment",
      "description": "Description",
      "descriptionPlaceholder": "Describe the goal of this assessment",
      "instructions": "Instructions",
      "instructionsPlaceholder": "Specific instructions for students",
      "passingScore": "Passing score (%)",
      "timeLimit": "Time limit (minutes)",
      "timeLimitPlaceholder": "Leave empty for no limit",
      "allowRetries": "Allow retries",
      "allowRetriesHelp": "Students can retake the assessment",
      "showResults": "Show results",
      "showResultsHelp": "Show score when finished",
      "showCorrectAnswer": "Show correct answers",
      "showCorrectAnswerHelp": "Show answer key when finished",
      "randomizeOrder": "Random order",
      "randomizeOrderHelp": "Shuffle questions and options",
      "maxRetries": "Maximum attempts",
      "maxRetriesPlaceholder": "Leave empty for unlimited"
    },
    "questions": {
      "title": "Questions",
      "add": "Add Question",
      "emptyTitle": "No questions created",
      "emptyDescription": "Add questions to build your quiz",
      "first": "First Question",
      "question": "Question *",
      "questionPlaceholder": "Type your question here...",
      "points": "Points",
      "explanation": "Explanation (optional)",
      "explanationPlaceholder": "Explanation shown after answering",
      "options": "Answer Options",
      "addOption": "Add Option",
      "true": "True",
      "false": "False",
      "optionPlaceholder": "Option text"
    },
    "questionTypes": {
      "multipleChoice": "Multiple Choice",
      "trueFalse": "True/False",
      "essay": "Essay"
    }
  },
  "quizStats": {
    "passed": "Passed",
    "failed": "Failed",
    "attempts": "Attempts",
    "title": "Statistics: {{title}}",
    "description": "Quiz response statistics",
    "totalAttempts": "Total Attempts",
    "totalAttemptsHelp": "Attempts made",
    "passRate": "Pass Rate",
    "passRateHelp": "{{passed}} of {{total}} passed",
    "averageScore": "Average Score",
    "averageScoreHelp": "Overall average across attempts",
    "passedHelp": "Passed attempts",
    "details": "Quiz Details",
    "questions": "Questions",
    "questionsCount_one": "{{count}} question",
    "questionsCount_zero": "{{count}} questions",
    "questionsCount_other": "{{count}} questions",
    "passingScore": "Passing score",
    "timeLimit": "Time limit",
    "minutes_one": "{{count}} minute",
    "minutes_zero": "{{count}} minutes",
    "minutes_other": "{{count}} minutes",
    "retries": "Retries",
    "maxRetries": "Maximum {{max}}",
    "unlimited": "Unlimited",
    "notAllowed": "Not allowed",
    "questionOrder": "Question order",
    "random": "Random",
    "fixed": "Fixed",
    "results": "Results",
    "showScore": "Show score",
    "hideScore": "Hide score",
    "showAnswerKey": "Show answer key",
    "distribution": "Results Distribution",
    "passedCount": "Passed ({{value}})",
    "failedCount": "Failed ({{value}})",
    "summary": "Overall Summary",
    "emptyTitle": "No attempts recorded",
    "emptyDescription": "No student has taken this quiz yet."
  }
}
